<template></template>
<script>
export default {
  mounted() {
    this.$store
      .dispatch("documents/delete", this.$route.params.id)
      .then(resp => {
        this.$router.push({ name: "documents" });
        this.$notify({
          type: "success",
          message: this.$t('document.message.successdelete')
        });
      })
      .catch(error => {
        this.$notify({
          type: "danger",
          message: this.$t('document.message.errordelete')
        });
      });
  }
};
</script>
<style>
</style>
